import React from "react";

/** Small inline label shown next to a guest angler's name. */
export function GuestTag() {
  return (
    <span className="ml-1 rounded-full bg-inset px-1.5 py-0.5 text-[10px] font-medium text-secondary">
      Guest
    </span>
  );
}

/** One-line summary row for a session angler. */
export function AnglerRow({
  displayName,
  isGuest,
  pegOrSwim,
  rodsCount,
  catchCount,
}: {
  displayName: string;
  isGuest: boolean;
  pegOrSwim?: string | null;
  rodsCount: number;
  catchCount: number;
}) {
  return (
    <div className="min-w-0">
      <p className="text-sm font-semibold text-primary">
        {displayName}
        {isGuest ? <GuestTag /> : null}
      </p>
      <p className="mt-0.5 text-xs text-secondary">
        {pegOrSwim ? `${pegOrSwim} · ` : ""}
        {rodsCount} {rodsCount === 1 ? "rod" : "rods"} · {catchCount}{" "}
        {catchCount === 1 ? "catch" : "catches"}
      </p>
    </div>
  );
}
